import React from 'react'
import { Button, Segment } from 'semantic-ui-react'

import { Margin } from 'elements/Margin'
import useAxios from 'hooks/useAxios'
import IntercomTicketCustomFieldSelector from './IntercomTicketCustomFieldSelector'
import SurveyIntegrationContentAndImageLayout from 'components/SurveyIntegrationContentAndImageLayout'

export default function UpdateTicketCustomFieldIntegration({
  integrationSetting,
  surveyToken,
  surveyId,
  isAuthenticated,
}) {
  const {
    data: customFields,
    fetch: getCustomFields,
    loading: isSyncing,
  } = useAxios({
    url: `survey/survey/${surveyToken}/custom-field-sync-option/`,
    skip: !isAuthenticated,
  })

  function handleResync() {
    getCustomFields()
  }

  function mapCustomFieldToOption(customFields) {
    return customFields.map((customField) => ({
      key: customField.id,
      text: customField.name,
      value: customField.id,
    }))
  }

  function filterCustomFieldType(type, customFields) {
    return customFields.filter((customField) => customField.type === type)
  }

  const integerCustomFieldOptions = customFields
    ? mapCustomFieldToOption(filterCustomFieldType('integer', customFields))
    : []

  const stringCustomFieldOptions = customFields
    ? mapCustomFieldToOption(filterCustomFieldType('string', customFields))
    : []

  const listCustomFieldOptions = customFields
    ? mapCustomFieldToOption(filterCustomFieldType('list', customFields))
    : []

  const customFieldOptions = [...stringCustomFieldOptions, ...listCustomFieldOptions]

  const disabled = !isAuthenticated || !customFields || isSyncing

  return (
    <React.Fragment>
      <SurveyIntegrationContentAndImageLayout
        imageUrl="https://cdn.simplesat.io/intercom/update-conversation-custom-attributes-with-rating-details.png"
        imageDescription="Update conversation custom attributes  with rating details"
      >
        <p>Choose the custom attributes you'd like to map answer details to.</p>
        <a
          href="https://help.simplesat.io/en/articles/5230032-intercom-integration#h_ffe8a17380"
          target="_blank"
          rel="noreferrer"
        >
          <i className="far fa-book icon" />
          Learn more about updating conversation custom attributes with rating details
        </a>
      </SurveyIntegrationContentAndImageLayout>

      <Segment.Group>
        <IntercomTicketCustomFieldSelector
          fieldKey="rating"
          name="Rating"
          description="Rating value expressed as a number"
          surveyToken={surveyToken}
          surveyId={surveyId}
          options={integerCustomFieldOptions}
          integrationSetting={integrationSetting}
          disabled={disabled}
          isSyncing={isSyncing}
        />

        <IntercomTicketCustomFieldSelector
          fieldKey="sentiment_label"
          name="Sentiment"
          description={<span>Sentiment of the rating: Positive, Neutral or Negative</span>}
          surveyToken={surveyToken}
          surveyId={surveyId}
          options={customFieldOptions}
          integrationSetting={integrationSetting}
          disabled={disabled}
          isSyncing={isSyncing}
        />

        <IntercomTicketCustomFieldSelector
          fieldKey="follow_up_comment"
          name="Comment"
          description="Text follow-up comment associated with the rating"
          surveyToken={surveyToken}
          surveyId={surveyId}
          options={customFieldOptions}
          integrationSetting={integrationSetting}
          disabled={disabled}
          isSyncing={isSyncing}
        />
      </Segment.Group>

      <div
        style={{
          textAlign: 'right',
        }}
      >
        <Margin right="0">
          <Button basic onClick={handleResync} disabled={disabled}>
            <i className="far fa-sync icon" />
            Resync Intercom fields
          </Button>
        </Margin>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomInAppPublish/UpdateTicketCustomFieldIntegration/index.js